import Settings from './settings'
import { currencies, currencyTextsConfig } from '../constants/dossier/common/currencies'

export default {
  ...Settings,
  urlHotFolder: '',
  webSocketUrl: 'wss://demo-itgroup.idoccar.com:8006',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .msg, .tiff',
  qaSite: false,
  dealerMaxLength: 6,
  dealerNumberRegex: null,
  dashboardWithProcedure: true,
  autoLoadDashboard: true,
  clientFieldValidation: 'buss',
  maxTagCount: 2,
  maxTagTextLength: 10,
  matomoSiteId: '84',
  currency: currencies.USD,
  currencyRegex: [/^[$][+-]?(\d{1,3}\.(\d{3}\.)*\d{3}|\d*)(,\d+)?$/, /^[+-][$]?(\d{1,3}\.(\d{3}\.)*\d{3}|\d*)(,\d+)?$/],
  currencyTextConfig: currencyTextsConfig.USD
}
